import React from 'react';
import PropTypes from 'prop-types';

import Popup from '@ecp/common/src/components/modal/bo/Popup';
import { SwiperImageView } from '@ecp/common/src/components/swiper/bo/SwiperTemplate';

const ImageViewPopup = ({ open, onClose, items, initialSlide, itemProps, ...props }) => {
  return (
    <Popup type={'Image'} open={open} onClose={onClose} onConfirmClick={props.useConfirmButton && onClose} {...props}>
      <SwiperImageView itemList={items} initialSlide={initialSlide} itemProps={itemProps} />
    </Popup>
  );
};

ImageViewPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  itemProps: PropTypes.object,
  items: PropTypes.arrayOf(PropTypes.object),
  header: PropTypes.string,
  useCancelButton: PropTypes.bool,
  useConfirmButton: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  useScroll: PropTypes.bool,
  initialSlide: PropTypes.number,
};

ImageViewPopup.defaultProps = {
  items: [],
  header: '이미지 크게 보기',
  useCancelButton: false,
  useConfirmButton: true,
  confirmButtonText: '닫기',
  useScroll: false,
  initialSlide: 0,
};
export default ImageViewPopup;
